import styled, { css } from "styled-components";

const pageHeaderSize = css`
  font-size: clamp(0.6rem, 0.425rem + 0.35vw, 0.9rem); // 11px
`;

export const tableHeaderSize = css`
  font-size: clamp(0.6rem, 0.425rem + 0.35vw, 0.9rem); // 11px
`;

export const creditHeaderSize = css`
  font-size: clamp(0.7rem, 0.5315rem + 0.3vw, 1.2rem); // 12px
`;

const campaignHeaderSize = css`
  font-size: clamp(0.75rem, 0.6rem + 0.4vw, 1.16rem); // 15px
`;

const totalSize = css`
  font-size: clamp(1.3rem, 1.2rem + 0.4vw, 1.55rem); // 25px
`;

export const OverviewCards = styled.div`
  background: #eff1fc;
  margin: 30px auto 15px;
  min-width: 560px;
  max-width: 600px;

  @media screen and (width < 1020px) {
    min-width: 60%;
    max-width: 60%;
  }

  @media screen and (width < 800px) {
    max-width: 90%;
    min-width: 90%;
  }
`;

export const DetailsReview = styled.div`
  background: rgba(220, 224, 252, 0.4);
  min-width: 35%;
  border-left: 1px solid #dce0fc;
  position: relative;

  @media screen and (width < 1020px) {
    min-width: 60%;
    margin: 0 auto;
    border-radius: 10px;
    border: 1px solid #dce0fc;
  }

  @media screen and (width < 800px) {
    max-width: 90%;
    min-width: 90%;
  }
`;

export const DetailsSticky = styled.div`
  max-width: 420px;
  margin-right: auto;
  padding: 30px 10% 30px 20px;

  @media screen and (width > 1380px) {
    max-width: 600px;
  }

  @media screen and (width < 1020px) {
    padding: 15px;
    margin-right: unset;
    max-width: unset;
  }
`;

export const ReviewContainer = styled.div`
  display: flex;
  gap: 40px;
  background: #eff1fc;
  margin-top: -20px;
  min-height: 100vh;
  flex-wrap: wrap;

  @media screen and (width < 1020px) {
    min-height: unset;
    gap: 0;
    padding-bottom: 32px;
  }
`;

export const PageHeader = styled.h1`
  ${pageHeaderSize};
  margin: 0 0 6px;
  color: #4056f4;
  font-weight: 400;
  word-wrap: break-word;
`;

export const CampaignCard = styled.div`
  border-radius: 10px;
  border: 1px solid #dce0fc;
  background: rgba(220, 224, 252, 0.4);
  padding: 15px;
  margin: 15px 0;
  width: 100%;
  cursor: pointer;

  @media screen and (width < 1020px) {
    width: unset;
  }
`;

export const CampaignText = styled.div`
  padding: 0 6px;
`;

export const CampaignHeader = styled.h2`
  ${campaignHeaderSize};
  color: #000;
  font-weight: 500;
  margin: ${({ inCollapse }) => (inCollapse ? "0" : "0 0 16px;")};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  div {
    display: grid;
    place-content: center;
  }
`;

export const HorizontalLine = styled.hr`
  border: none;
  height: 1px;
  background: #abb4f4;
  width: 100%;
  background: ${({ dotted }) => (dotted ? "none" : "#abb4f4")};
  border-bottom: ${({ dotted }) => (dotted ? "1px dotted #abb4f4" : "none")};
  margin: ${({ margin }) => (margin ? margin : "16px 0")};
`;

export const DetailsCard = styled.div`
  padding: 0 14px;
`;

export const CreditHeader = styled.div`
  ${creditHeaderSize};
  color: #4056f4;
  font-weight: 400;
  line-height: 17px;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const CampaignCostSpacer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: ${({ pushSides }) => (pushSides ? "0 14px" : "0")};
  button {
    align-self: flex-start;
  }
`;

export const CampaignCost = styled.div`
  ${campaignHeaderSize};
  text-align: right;
  font-weight: 700;
  color: #1e1f43;
  position: relative;
  opacity: ${({ hide }) => (hide ? "0" : "1")};
  transition: opacity 0.2s ease;

  div {
    color: ${({ strike }) => (strike ? "#1E22FF" : "#7a89f4")};
    text-decoration: ${({ strike }) => (strike ? "line-through" : "none")};
    font-weight: 500;
    display: inline-flex;
    margin-right: 8px;
  }
  span {
    color: #7a89f4;
    font-weight: 500;
    font-size: 12px;
  }
`;

export const SumRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  p {
    ${creditHeaderSize};
    color: #4056f4;
    font-family: Rubik;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
  }
  h4 {
    margin: 0;
    color: #1e1f43;
    font-family: Rubik;
    font-style: normal;
    ${({ isFinal }) => (isFinal ? totalSize : campaignHeaderSize)};
    font-weight: ${({ isBold, isFinal }) => (isBold || isFinal ? 700 : 400)};
    line-height: normal;

    span {
      font-weight: ${({ isBold }) => (isBold ? 700 : 400)};
      font-size: 15px;
    }
  }
`;

export const DetailsText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const CollapseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 6px;
  margin-bottom: ${({ collapse }) => (collapse ? "0" : "16px;")};
`;

export const CollapsePrice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const CollapseIcon = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    transition: transform 0.3s ease;
    transform: ${({ rotateIcon }) => (rotateIcon ? "rotate(180deg)" : "rotate(0deg)")};
  }
`;
